import styled from 'styled-components'

export const StyledDivision = styled.div`
  /* padding-top: 100px; */
  text-align: center;
  line-height: 1.5;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 11px;
`
export const NumberDiv = styled.div`
  padding-top: 10px;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 35px;
`
export const MainDiv = styled.div`
  border: #d8ddff 2px solid;
  border-radius: 20px;
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: left;
  align-items: left;
  // padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 10px;
  padding-right: 10px;
  width: 246px;
  height: 25em;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 5px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #c1c1c1; /* Optional: Color of the scrollbar thumb */
    border-radius: 10px; /* Optional: Round the scrollbar thumb */
  }
`

export const StudentDiv = styled.div`
padding: 10px;
width: 100%;
left: 0;
top: 0;
position: sticky;
z-index: 1;
background-color: white;

`

export const Dummy = styled.div`
  font-size: 17px;
  padding-bottom: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  text-align: center;
  color: grey;
`

export const Chips = styled.div`
  border: 1px solid #3249d7;
  border-radius: 14px;
  font-size: 10px;
  color: #000000;
  padding: 1px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  padding-right: 10px;
  margin-bottom: 10px;
  gap: 20px;
  width: fit-content;
`
export const StyledRightStick = styled.div`
  padding-left: 20px;
  position: absolute;
  right: 60px;
  margin-left: 10px;
  margin-top: 10px;
`
export const CustomDiv = styled.div`
cursor: pointer;
`